import {FlashcardRecord} from "../flashcardParser"

export interface FlashCardRecordWithInfo extends FlashcardRecord {
  revealed: boolean;
}

export type Action =
  UnselectCard |
  SelectedPair |
  SelectedAlreadyPaired |
  WrongPair |
  SelectedNew

interface UnselectCard {
  type: 'unselected-card';
  card: number;
}

interface SelectedPair {
  type: 'selected-pair';
  card: number;
  pair: number;
}

interface SelectedAlreadyPaired {
  type: 'selected-already-paired';
  card: number;
}

interface WrongPair {
  type: 'wrong-pair';
  card: number;
  pair: number;
}

interface SelectedNew {
  type: 'selected-new';
  card: number;
}

export class MemoryGame {
  cards: FlashCardRecordWithInfo[]
  selectedCardPos?: number

  constructor(cards: FlashcardRecord[]) {
    this.cards = cards.map(x => ({...x, revealed: false}))
    this.selectedCardPos = undefined
  }

  get allRevealed(): boolean {
    return this.cards.every(x => x.revealed)
  }

  select(cardPos: number): Action {
    const card = this.cards[cardPos]
    if (this.selectedCardPos === cardPos) {
      this.cards[this.selectedCardPos].revealed = false
      this.selectedCardPos = undefined
      return {
        type: 'unselected-card',
        card: cardPos
      }
    } if (this.selectedCardPos !== undefined) {
      const selectedCard = this.cards[this.selectedCardPos]
      if (selectedCard.front === card.front) {
        card.revealed = true
        const selectedCardPos = this.selectedCardPos
        this.selectedCardPos = undefined
        return {
          type: 'selected-pair',
          card: cardPos,
          pair: selectedCardPos
        }
      } else if (card.revealed) {
        return {
          type: 'selected-already-paired',
          card: cardPos,
        }
      } else {
        selectedCard.revealed = false
        const selectedCardPos = this.selectedCardPos
        this.selectedCardPos = undefined
        return {
          type: 'wrong-pair',
          card: cardPos,
          pair: selectedCardPos
        }
      }
    } else {
      if (!card.revealed) {
        this.selectedCardPos = cardPos
        card.revealed = true
        return {
          type: "selected-new",
          card: cardPos
        }
      }
      return {
        type: "selected-already-paired",
        card: cardPos
      }
    }
  }
}
